import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    LaneGroupTemperatureRange,
    RegionFirstLevel,
} from 'app/enums/label.enums'

import {
    RegionalGroup,
} from 'app/Apps/AccountManagement/RegionalGroups/regionalGroups.types'

const getFields = (
    {
        getAllowedValues,
        needSelectAccount,
    }: {
        getAllowedValues: (enumType: Record<string, string>) => Record<string, string>,
        needSelectAccount?: boolean,
    },
): DTOCardFormField<keyof RegionalGroup>[] => {
    return [{
        id: 'generalInformation',
        title: 'General Information',
        className: 'generalInformation',
        fields: [
            {
                id: 'column1',
                fields: [
                    {
                        name: 'account',
                        componentName: 'AccountSelector',
                        labelKey: 'RegionalGroups.accountName',
                        required: true,
                        disabled: !needSelectAccount,
                    },
                    {
                        name: 'tempRange',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(LaneGroupTemperatureRange),
                        labelKey: 'RegionalGroups.tempRange',
                        required: true,
                        useDropdown: true,
                    },
                ],
            },
            {
                id: 'column2',
                fields: [
                    {
                        name: 'originRegion',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(RegionFirstLevel),
                        labelKey: 'RegionalGroups.originRegion',
                        required: true,
                    },
                    {
                        name: 'annualPotentialVolume',
                        componentName: 'IntegerInput',
                        labelKey: 'RegionalGroups.annualPotentialVolume',
                        required: true,
                    },
                ],
            },
            {
                id: 'column3',
                fields: [
                    {
                        name: 'destinationRegion',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(RegionFirstLevel),
                        labelKey: 'RegionalGroups.destinationRegion',
                        required: true,
                    },
                    {
                        name: 'opportunityIndex',
                        componentName: 'IntegerInput',
                        labelKey: 'RegionalGroups.opportunityIndex',
                    },
                    {
                        name: 'additionalInformation',
                        labelKey: 'RegionalGroups.additionalInformation',
                        componentName: 'LongText',
                    },
                ],
            },
            {
                id: 'column4',
                fields: [{
                    name: 'supportingDocuments',
                    componentName: 'AttachmentsObjectSelector',
                    labelKey: 'RegionalGroups.supportingDocuments',
                }],
            },
        ],
    }]
}

export default getFields
